var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNight5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 58",
    style: {
      enableBackground: "new 0 0 51 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1866.3179,
    y1: 1904.368,
    x2: -1819.3999,
    y2: 1885.3026,
    gradientTransform: "matrix(0.9264 0.3765 -0.3765 0.9264 2446.1165 -1032.6714)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC53D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#EC7C47"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,57.5c-3.6,0-7.3-0.7-10.8-2.1c-7-2.9-12.5-8.3-15.5-15.3c-2.9-7-3-14.7-0.1-21.7 C6.4,8.3,15.8,1.5,26.7,0.8l4.3-0.3l-3.2,2.9c-2.9,2.6-5.1,5.7-6.5,9.3c-5.3,13,1,27.8,14,33.1l0,0c3.6,1.5,7.4,2.1,11.2,1.8 l4.3-0.3l-3.2,2.9C42.2,55,35.5,57.5,28.7,57.5z M22.7,4.4c-8,1.9-14.5,7.4-17.7,15.2C2.5,25.8,2.6,32.7,5.2,39 c2.6,6.2,7.6,11.1,13.8,13.7c7.8,3.2,16.3,2.3,23.2-2.1c-2.8-0.3-5.5-0.9-8.1-2c-14.5-5.9-21.5-22.5-15.6-37 C19.6,8.9,21,6.5,22.7,4.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNight5);
export default __webpack_public_path__ + "static/media/icon_night5.ea6b956fb72fd1b30b7dceb1950871f9.svg";
export { ForwardRef as ReactComponent };